import * as React from 'react';
import styled from 'styled-components';

interface IBarProps {
    widthStyle: number
};

const Bar = styled.div`
    background: #c4c4c4;
    height: 10px;
    width: ${(props: IBarProps) => `${props.widthStyle}%`};
    position: fixed;
    bottom: 0;
    left: 0;
`;

interface IProps {
    length: number,
    progress: number
};

const ProgressBar = (props: IProps) => {
    const width = props.progress ? props.progress / props.length * 100 : 0;
    return <Bar widthStyle={width} aria-label={`${props.progress} of ${props.length} questions answered`} />
};

export default ProgressBar;


// WEBPACK FOOTER //
// ./src/SharedComponents/ProgressBar.tsx